/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Withdrawal_TitleInputs */

const da_terms_withdrawal_title = /** @type {(inputs: Terms_Withdrawal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortrydelsesret`)
};

/** @type {(inputs: Terms_Withdrawal_TitleInputs) => LocalizedString} */
const en_terms_withdrawal_title = da_terms_withdrawal_title;

/**

* @param {Terms_Withdrawal_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_withdrawal_title = /** @type {((inputs?: Terms_Withdrawal_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Withdrawal_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_withdrawal_title(inputs)
	return /** @type {LocalizedString} */ ("Fortrydelsesret")
});